import Urls from './Urls';
import {IsLP_MP_SP} from "my-styles/media/media";

export function callFinalApi(url, params, method, headers, onSuccess, onFailure, onStart, onEnd) {
    if (!headers) {
        if (!params) {
            params = new FormData()
        }

        url = Urls.baseUrlWithDefault + url

        let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
        headers = {
            'Authorization': 'bearer ' + token
        }
        params.append("from_web", '1')
        params.append("platform", IsLP_MP_SP() ? 2 : 3)
    }

    let dataFormat = {
        method: method,
        body: params,
        headers: headers
    }

    if (onStart) {
        onStart()
    }

    fetch(url, dataFormat)
        .then(response => {
            return response.json()
        })
        .then(data => {

            if (onEnd) {
                onEnd()
            }
            if (data.description === "101" || data.description === "102") {
                if (onFailure) {
                    onFailure(data)
                }
                return
            }
            if (data.result === "error") {
                if (onFailure) {
                    onFailure(data)
                }
                return
            }
            if (onSuccess) {
                onSuccess(data)
            }
        }).catch((error) => {
            if (onEnd) {
                onEnd()
            }
            if (onFailure) {
                onFailure(error)
            }
        }
    )
}

export function callApi(url, params, onSuccess, onFailure, onStart, onEnd) {
    callFinalApi(url, params, 'POST', undefined, onSuccess, onFailure, onStart, onEnd)
}

export function callExternalApi(url, params, method, headers, onSuccess, onFailure, onStart, onEnd) {
    callFinalApi(url, params, method, headers, onSuccess, onFailure, onStart, onEnd)
}

export function callEmptyParamsApi(url, onSuccess, onFailure, onStart, onEnd) {
    callApi(url, new FormData(), onSuccess, onFailure, onStart, onEnd)
}